// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3AGfK","tableRow":"styles_tableRow__1wbK3","sorted":"styles_sorted__2wEMy"};